import React, { Component } from 'react'
import { Spin, Form, Layout, Icon, PageHeader, Input, Upload, Calendar } from 'antd'
import moment from 'moment'

import PrevImg from '_src/components/PrevImg/PrevImg'
import {travelDetail} from '_src/api/api'

import './style.less'

function getTypeName (type) {
  switch (type) {
  case 1:
    return '省内游'
  case 2:
    return '国内游'
  case 3:
    return '出境短游'
  case 4:
    return '出境长游'
  default:
    return '未知'
  }
}

@Form.create({name: ''})
class CreateTravel extends Component {
  constructor (props) {
    super(props)
    // 3个月区间
    let newDate = new Date()
    newDate.setMonth((newDate.getMonth())+3)
    this.state = {
      isLoading: true,
      fileList: [],
      startDate: moment().format('YYYY-MM-DD'),
      endDate: moment(newDate).format('YYYY-MM-DD'),
      travelDates: [],
    }
  }

  componentDidMount () {
    const id = this.props.location.search.replace('?id=', '')
    travelDetail({id})
      .then(res => {
        const fileList = []
        JSON.parse(res.data.gallery).forEach((item, index) => {
          fileList.push({ uid: index, name: 'xxx.png', status: 'done', url: item})
        })
        this.setState({
          info: res.data,
          fileList,
          isLoading: false,
          travelDates: res.data.dates,
        })
      })
  }

  // 日历时间可选判断
  disabledDate = (item) => {
    const {startDate, endDate} = this.state
    item = moment(item).format('YYYY-MM-DD')
    return item < startDate || item > endDate
  }
  // 日历单元格渲染
  dateCellRender = (item) => {
    const {startDate, endDate, travelDates} = this.state
    item = moment(item).format('YYYY-MM-DD')
    // 不可设置内容区域
    if (item < startDate || item > endDate) {
      return <div className='data-after-content flex-a'>/</div>
    } 
    const curObj = travelDates.filter(ele => ele.date === item)[0]
    if (curObj) {
      return (
        <div className='data-after-content'>
          <div><span style={{fontSize: 12}}>票数：</span>{curObj.tickets}张</div>
          <div className='price'><span style={{fontSize: 12}}>售价：</span>{(curObj.salePrice / 100).toFixed(2)}</div>
          <div className='price-default'><span style={{fontSize: 12}}>原价：</span>{(curObj.costPrice / 100).toFixed(2)}</div>
        </div>
      )
    }
    return <div className='data-after-content not-content flex-a'>未设置</div>
  }

  // 图片预览 
  handlePreview = (file) => this.PrevImg.show(file.url)
  // 选择图片回调
  handleChange = ({ fileList }) => this.setState({ fileList })

  render () {
    const {
      info,
      isLoading,
      fileList,
    } = this.state
    return (
      <Layout className="createTravel-page" style={{ padding: 20, paddingTop: 40, backgroundColor: 'white' }}>
        {isLoading ? <Spin t1ip="Loading..." className="loading" size='large' /> : ''}
        <PrevImg ref={el => this.PrevImg = el} />
        <PageHeader className='flex-h-a' title='查看旅游专线' style={{borderLeft: '5px solid #1890ff', height: 30}} />
        {
          info && (
            <div className="" style={{paddingTop: 20}}>
              <Form onSubmit={this.handleSubmit} style={{paddingLeft: 30}}>
                <PageHeader title={<span><Icon type="profile" /> 基本信息</span>} style={{paddingLeft: 0}} />
                <Form.Item label="旅游专线名称：" className='flex'>
                  <Input value={info.travelName} style={{width: 400}} readOnly />
                </Form.Item>
                <Form.Item label="线路类型：" className='flex'>
                  <Input value={getTypeName(info.travelType)} style={{width: 400}} readOnly />
                </Form.Item>
                <Form.Item label="合作方" className='flex'>
                  <Input value={info.partner} style={{width: 400}} readOnly />
                </Form.Item>
                <Form.Item label="状态" className='flex'>
                  <span>{info.status === 0 ? '上架（使用中）' : '下架'}</span>
                </Form.Item>
                <Form.Item label="商品大图" className='flex'>
                  <Upload
                    className='upload-img flex-j-a'
                    action=""
                    multiple
                    listType="picture-card"
                    fileList={fileList}
                    onPreview={this.handlePreview}
                    onChange={this.handleChange}
                    beforeUpload = {()=>{ return false }}
                    onRemove={()=>false}
                  />
                </Form.Item>
                <div style={{marginTop: 50}}>
                  <PageHeader title={<span><Icon type="profile" /> 出游日期</span>} style={{paddingLeft: 0, marginBottom: 20}} />
                  <div className='Calendar-inner'>
                    <Calendar disabledDate={this.disabledDate} dateCellRender={this.dateCellRender} />
                  </div>
                </div>
                <div style={{marginTop: 50}}>
                  <PageHeader title={<span><Icon type="profile" /> 商品描述</span>} style={{paddingLeft: 0, marginBottom: 20}} />
                  <div dangerouslySetInnerHTML={{__html: info.detail}} style={{width: 600}} />
                </div>
              </Form>
            </div>
          )
        }
      </Layout>
    )
  }
}

export default CreateTravel